// extracted by mini-css-extract-plugin
export default {"main":"sortDropdown_main__k97Oi","chevron":"sortDropdown_chevron__JS9UX"};